var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con",class:[_vm.$t("language.type"), {pd_top70: _vm.isFixedNavBar}]},[_c('TopNavbar'),_c('AppMain'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }